import { FixtureTypes } from '@shared/utils/constants';
import { GetVoyageDetailsResponse } from '@api/features/voyages/getVoyageDetails';
import { GetFixtureDetailsResponse } from '@api/features/fixtures/getFixtureDetails';
import { TcFixtureProps } from '@api/models/tc-fixture';
import getAvailableHireInvoiceItems from './getAvailableHireInvoiceItems';
import getHireCapDate from './getHireCapDate';
import extendLastDeclaredPeriodToMax from './extendLastDeclaredPeriodToMax';

// voyageDetails and fixtureDetails are the objects returned from
// the getVoyageDetails and getFixtureDetails features respectively
const getAvailableHIIsFromTcDetails = (
	voyageDetails: GetVoyageDetailsResponse,
	fixtureDetails: GetFixtureDetailsResponse<TcFixtureProps>,
	hireInvoices: GetVoyageDetailsResponse['hireInvoices'],
	isHireInvoice: boolean,
	useLegacyTime: boolean,
) => {
	const {
		completionDate,
		deliveryDate,
		voyageBunkers,
		voyageExpenseReceivables,
		voyageOffHirePeriods,
		readyForCumulative,
		ballastBonusAvailable,
		amendments,
		periodSchedule,
	} = voyageDetails;

	const {
		brokers,
		bankAccount,
		type,
		hireDaysDecimals,
	} = fixtureDetails;

	const hireCapDate = getHireCapDate(voyageDetails, type) ?? completionDate ?? null;

	const tcTerms = voyageDetails.tcTerms;

	const {
		hireUnit,
		useUTC,
		calculationMethodForExpensesSubjectToHireDays,
		grossBallastBonus,
		daysPerHirePeriod,
		invoicePerCalenderMonth,
		hireDescription,
		addressCommission,
		ExpensesSubjectToHireDays,
		RevenuesSubjectToDays
	} = tcTerms;

	if (type === FixtureTypes.SPOT) {
		return [];
	}

	// Users cannot fix TC estimates without most of these values - so we assume they are not null
	return getAvailableHireInvoiceItems({
		hireDaysDecimals,
		isHireInvoice,
		commencementDate: deliveryDate,
		completionDate: hireCapDate,
		hireInvoices,
		daysPerHirePeriod: daysPerHirePeriod ?? 15,
		invoicePerCalenderMonth: invoicePerCalenderMonth ?? null,
		type: type!,
		periodSchedule: type === FixtureTypes.TC_OUT ?
			extendLastDeclaredPeriodToMax(periodSchedule) :
			periodSchedule,
		hireDescription: hireDescription ?? null,
		expensesSubjectToHireDays: ExpensesSubjectToHireDays ?? [],
		revenuesSubjectToDays: RevenuesSubjectToDays,
		calculationMethodForExpensesSubjectToHireDays: calculationMethodForExpensesSubjectToHireDays ?? null,
		addressCommission: addressCommission!,
		brokers: brokers ?? [],
		grossBallastBonus: grossBallastBonus ?? null,
		ballastBonusAvailable,
		readyForCumulative,
		voyageBunkers,
		voyageExpenseReceivables,
		voyageOffHirePeriods,
		bankAccount,
		useUTC,
		hireUnit,
		useLegacyTime,
		amendments
	});
};

export default getAvailableHIIsFromTcDetails;
